import { capitalize } from "lodash-es";
import { EditorLinkToMergeField } from "@dev/template-editor";
import { useSpecialFields } from "./useSpecialFields";

export const useEditorLinkToMergeFields = (fields: string[], fixedFields: EditorLinkToMergeField[] = []): EditorLinkToMergeField[] => {
    const specialFields = useSpecialFields({ isButton: false });
    return [...specialFields.fields.filter((field) => fields.includes(field.exactFormat)).map((field) => ({
        name: field.exactFormat,
        label: capitalize(field.name),
        value: field.exactFormat,
        useAdditionalInput: false,
        format: () => `{${field.exactFormat}}`,
    })), ...fixedFields];
};
